import { JsonObject } from 'ta-json';
import {
  GetAllRetailers_allRetailers_edges_node_retailerOptions_eanOptions,
} from '@src/app/generated/GetAllRetailers';
import { EanOptions } from '@ess/jg-rule-executor/dist/src/domain/ean-options';
import { EanOptionsInput } from '@src/app/generated/globalTypes';

/**
 * EanOptions
 */
@JsonObject()
export class PortalEanOptions extends EanOptions {
  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_eanOptions): PortalEanOptions {
    return new PortalEanOptions(
      gql.eanEnabled
    );
  }

  toGqlInput(): EanOptionsInput {
    return {
      eanEnabled: this.eanEnabled,
    };
  }
}
